import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../../common/views/SMLButton/SMLButton';
import { Panel } from '../../music24/components/primitives/Panel';
import styles from './SMLStatsUnavailable.module.scss';

interface SMLStatsUnavailableProps {
  retry: () => void;
}

/**
 * Shown when the analytics request fails.
 *
 * Deliberately a panel, not a full-page error: analytics is one section of the
 * page. A SmartLink's link, preview and settings do not depend on it, and
 * replacing the whole page with an error when only the numbers are missing
 * takes away the parts that still work.
 */
const SMLStatsUnavailableComponent: React.FC<SMLStatsUnavailableProps> = ({ retry }) => {
  const intl = useIntl();
  return (
    <Panel className={styles.panel}>
      <p className={styles.text}>
        {intl.formatMessage({
          id: 'app.sml.stats.unavailable',
          defaultMessage: 'Could not load your numbers just now.',
        })}
      </p>
      <SMLButton onClick={retry} outline>
        {intl.formatMessage({ id: 'app.buttons.try_again', defaultMessage: 'Try Again' })}
      </SMLButton>
    </Panel>
  );
};

export const SMLStatsUnavailable = TypedMemo(SMLStatsUnavailableComponent);
